import React from 'react';
import { BurgerButton } from '../styles';

interface BurgerMenuProps {
  onClick: () => void;
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({ onClick }) => {
  return (
    <BurgerButton onClick={onClick}>
      <span></span>
      <span></span>
      <span></span>
    </BurgerButton>
  );
};

export default BurgerMenu;
